<!-- プラン詳細 直接申込 -->
<template>
  <div class="p-menu-direct-application__applicationDetails">
    <div
      class="p-menu-direct-application__description"
      :class="{ affiliate: hasAffiliateCoupons }"
    >
      本プランは外部サービスへのお申込みとなります。<br /><a
        href="#p-menus-no-plan-detail_shopping-guide"
        >ショッピングガイド</a
      >をご確認のうえ、サービス提供企業へ直接お申込みください。
      <template v-if="hasAffiliateCoupons">
        <div
          class="affiliate-coupons"
          v-for="(coupon, index) in affCouponsAvailable"
          :key="index"
        >
          <p class="coupon-name">{{ coupon.couponCodeNm }}</p>
          <div class="coupon-details">
            <p class="coupon-code">{{ coupon.couponCd }}</p>
            <a
              href="javascript:;"
              class="c-button__tertiary"
              @click.prevent="$copy.CopyToClipboard(coupon.couponCd)"
              ><span>クーポンコードをコピー</span></a
            >
          </div>
          <p class="coupon-explanation">{{ coupon.couponCdExplanation }}</p>
        </div>
      </template>
    </div>

    <div
      v-if="planData.applFlag == 1"
      class="p-menu-direct-application__application"
      :class="{ affiliate: hasAffiliateCoupons }"
    >
      <!-- WEBでの申込 -->
      <div v-if="isWebApplication" class="p-menu-direct-application__way">
        <div class="p-menu-direct-application__application_title">
          WEBでのお申込み
        </div>
        <div>
          <div class="c-buttonWrap4">
            <Button
              style-type="primary"
              color="color2"
              @click.native="clickWebBtn()"
              class="c-button__primary--color2"
              >WEBで申し込む</Button
            >
          </div>
        </div>
      </div>
      <!-- メールでの申込 -->
      <div v-if="isMailApplication" class="p-menu-direct-application__way">
        <div class="p-menu-direct-application__application_title">
          メールでのお申込み
        </div>
        <div>
          <div class="c-buttonWrap4">
            <a
              :href="'mailto:' + this.planData.usageDetailLife.applEmailAddr"
              class="c-button c-button__primary c-button__primary--color2"
              ><span class="p-menu-direct-application__icon"
                ><Icon name="sns_mail" color="#fff"/></span
              >メールで申し込む</a
            >
          </div>
        </div>
      </div>
      <!-- Faxでの申込 -->
      <div v-if="isFaxApplication" class="p-menu-direct-application__way">
        <div class="p-menu-direct-application__application_title">
          FAXでのお申込み
        </div>
        <div>
          <div class="c-buttonWrap4">
            <Button
              style-type="primary"
              color="color2"
              @click.native="clickFaxBtn"
              ><span class="p-menu-direct-application__icon"
                ><Icon name="contents_pdf" color="#fff"/></span
              >申請書</Button
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    planData: {
      type: Object,
      default: () => ({})
    },
    error: {
      type: String,
      default: ""
    },
    pageData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      mail: null
    };
  },
  created() {
    if (this.planData.usageDetailLife.applEmailAddr) {
      this.mail = "mailto:" + this.planData.usageDetailLife.applEmailAddr;
    }
  },
  computed: {
    // WEB申込の表示判定
    isWebApplication() {
      return this.planData.usageDetailLife.applWebUrl;
    },
    // メール申込の表示判定
    isMailApplication() {
      return this.planData.usageDetailLife.applEmailAddr;
    },
    // FAX申請の表示判定
    isFaxApplication() {
      return this.planData.usageDetailLife.applFax;
    },
    hasAffiliateCoupons() {
      if (!this.planData?.usageDetailLife?.affiliateCoupons?.length) return false;
      let timeStampCurrent = new Date().getTime();
      for(const coupon of this.planData.usageDetailLife.affiliateCoupons){
        let timeStampCouponDate = coupon.couponCdEndDt ? new Date(coupon.couponCdEndDt).getTime():null;
        if(timeStampCouponDate && timeStampCouponDate >= timeStampCurrent) return true;
      }
      return false;
    },
    affCouponsAvailable() {
      if (!this.planData?.usageDetailLife?.affiliateCoupons?.length) return [];
      let timeStampCurrent = new Date().getTime();
      let couponsAvailable = [];
      for(const coupon of this.planData.usageDetailLife.affiliateCoupons){
        let timeStampCouponDate = coupon.couponCdEndDt ? new Date(coupon.couponCdEndDt).getTime():null;
        if(timeStampCouponDate && timeStampCouponDate >= timeStampCurrent) couponsAvailable.push(coupon);
      }
      return couponsAvailable;
    }
  },
  methods: {
    clickFaxBtn() {
      window.open(this.planData.usageDetailLife.applFax, "_blank", "");
    },
    clickWebBtn() {
      this.$emit("apply");
    }
  }
};
</script>

<style scoped lang="scss">
@import './p-menu-direct-application.scss';
.p-menu-direct-application__applicationDetails {
  .p-menu-direct-application__description {
    a {
      color: #1890ff;
      text-decoration: underline;
    }
    .affiliate-coupons {
      margin-top: 24px;
      .coupon-name {
        font-weight: 700;
        font-size: 16px;
        line-height: 150%;
      }
      .coupon-details {
        background: #eeeeee;
        border-radius: 4px;
        padding: 12px 16px;
        margin-top: 8px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        @media only screen and (max-width: 639px) {
          flex-flow: column;
        }
        .coupon-code {
          font-size: 20px;
          font-weight: 700;
          line-height: 150%;
          color: #222222;
          flex-grow: 1;
        }
        .coupon-explanation {
          margin-top: 8px;
        }
      }
    }
  }
}
</style>
